export class Status {
	id?: number;
	name?: string;
	constructor(init?: Partial<Status>) {
		Object.assign(this, init);
	}
}
